/* eslint-disable @nx/enforce-module-boundaries */
import { transformResponseList, transformResponse } from '../../utils/transformResponse/thinkAnalyticsResponse';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IApiPathManager } from '@intigral/domain/lib/infrastructures/config/ApiPathManager';
import { API_IDS } from '@intigral/constant';
import { log } from '@intigral/utils/lib/logger';
import { ErrorType } from '@intigral/utils';
import type { NetworkErrorInfo } from '@intigral/utils';
import user from '../../helpers/user';
import { IThinkAnalyticsService } from '@intigral/domain/lib/application/services/ThinkAnalyticsService';
import { EVENT } from '../../contexts/MixpanelConstants';
import { convertFilterParamsToObject } from '@intigral/utils/lib/helpers/string';

export const getRelatedApi = (params, trackError) => {
    const newParamsObject = params?.filter_params ? convertFilterParamsToObject(params?.filter_params) : {};
    newParamsObject['vodGuid'] = params.vodGuid;
    newParamsObject['itemGuid'] = params.vodGuid;
    const apiKey = user.getAPIKey();

    const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
    const moreLikeThisRes = taService.getRelated(apiKey, user.getIdentityToken(), newParamsObject);

    const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    const urlVal = apiPathManager.getPath(API_IDS?.THINK_ANALYTICS_API_GET_RELATED) ?? '';
    const url = apiPathManager.replacePlaceholders(urlVal, params?.filter_params);
    // const moreLikeThisRes = di.thinkanalytics.getRelated(apiKey, user.getIdentityToken(), newParamsObject);
    return new Promise((resolve, reject) => {
        moreLikeThisRes
            .then((response) => {
                if (response?.error) {
                    trackErrorEvent(response, url, trackError);
                }
                if (response && response.data.entries) {
                    resolve(transformResponseList(response.data));
                } else {
                    reject(response);
                }
            })
            .catch((errResponse) => {
                let res: any = {};
                res = JSON.parse(errResponse);
                handleError(errResponse, url, trackError);
                reject(errResponse);
            });
    });
};

export const getRelatedOthersApi = (stream, params, trackError) => {
    const newParamsObject = params?.filter_params ? convertFilterParamsToObject(params?.filter_params) : {};
    newParamsObject['vodGuid'] = params.vodGuid;
    newParamsObject['itemGuid'] = params.vodGuid;
    const apiKey = user.getAPIKey();
    const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
    const moreLikeThisRes = taService.getRelatedOthers(apiKey, user.getIdentityToken(), newParamsObject);

    const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    const urlVal = apiPathManager.getPath(API_IDS?.THINK_ANALYTICS_API_GET_RELATED_OTHERS) ?? '';
    const url = apiPathManager.replacePlaceholders(urlVal, params?.filter_params);

    return new Promise((resolve, reject) => {
        moreLikeThisRes
            .then((response) => {
                if (response?.error) {
                    trackErrorEvent(response, url, trackError);
                }
                if (response && response.data.entries) {
                    resolve(transformResponseList(response.data));
                } else {
                    reject(response);
                }
            })
            .catch((errResponse) => {
                let res: any = {};
                res = JSON.parse(errResponse);
                handleError(errResponse, url, trackError);
                reject(errResponse);
            });
    });
};

export const getThinkAnalyticVodListApi = (params, trackError) => {
    const newParamsObject = params?.filter_params ? convertFilterParamsToObject(params?.filter_params) : {};
    const apiKey = user.getAPIKey();
    const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
    const data = taService.getVodListAndYouWatched(apiKey, user.getIdentityToken(), newParamsObject);

    const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    const urlVal = apiPathManager.getPath(API_IDS?.THINK_ANALYTICS_API_GET_VODLIST_AND_YOU_WATCHED) ?? '';
    const url = apiPathManager.replacePlaceholders(urlVal, params?.filter_params);

    return data
        .then((response) => {
            if (response?.error) {
                trackErrorEvent(response, url, trackError);
            }
            if (response && response.data && response.data.entries) {
                return transformResponseList(response.data);
            }
        })
        .catch((errResponse) => {
            handleError(errResponse, url, trackError);
        });
};

export const getBecauseYouWatchedApi = (params) => {
    const newParamsObject = params?.filter_params ? convertFilterParamsToObject(params?.filter_params) : {};
    // const queryparams = this.__replacePlaceholderParams(params?.filter_params);
    // let splitQueryParams = queryparams.split('&');
    // splitQueryParams.forEach((item) => {
    //     let split = item?.split('=');
    //     newParamsObject[split[0]] = split[1];
    // });
    const apiKey = user.getAPIKey();
    const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
    const data = taService.getVodListAndYouWatched(apiKey, user.getIdentityToken(), newParamsObject);

    return data.then((response) => {
        if (response && 'data' in response && 'entries' in response.data) {
            const { watchedTitle, watchedTitleLocalized } = response.data;
            if (response.data.entries.length > 0) {
                return transformResponse(response.data.entries, {
                    en: watchedTitle,
                    ar: watchedTitleLocalized.ar,
                });
            } else {
                transformResponse([], { en: '', ar: '' });
            }
        }
    });
};

export const getBecauseYouWatchedMultipleApi = (params) => {
    const newParamsObject = params?.filter_params ? convertFilterParamsToObject(params?.filter_params) : null;
    const apiKey = user.getAPIKey();
    const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
    const data = taService.getBecauseYouWatchedMultiple(apiKey, user.getIdentityToken(), newParamsObject);

    const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    const urlVal = apiPathManager.getPath(API_IDS?.THINK_ANALYTICS_API_GET_BECAUSE_YOU_WATCH_MULTIPLE) ?? '';
    const url = apiPathManager.replacePlaceholders(urlVal, params?.filter_params);

    return data.then((response) => {
        if (response && 'data' in response && 'entries' in response.data) {
            const { watchedTitle, watchedTitleLocalized } = response.data;
            if (response.data.entries.length > 0) {
                return transformResponse(response.data.entries, {
                    en: watchedTitle,
                    ar: watchedTitleLocalized.ar,
                });
            } else {
                transformResponse([], { en: '', ar: '' });
            }
        }
    });
};

export const getZoneApi = async (url) => {
    const apiKey = user.getAPIKey();
    const userName = user.getUsername();
    const profileName = user.getProfileName();
    const token = user.getIdentityToken();

    try {
        const taService = container.resolve<IThinkAnalyticsService>(DI.SERVICES.IThinkAnalyticsService);
        const zoneUseCases = await taService.getZone(url, token, apiKey, profileName, userName);
        return zoneUseCases?.data?.useCases ?? [];
    } catch (error) {
        return [];
    }
};

const handleError = (errResponse, url, trackError) => {
    if (errResponse?.networkError) {
        const errorInfo: NetworkErrorInfo = {
            ...errResponse.networkError,
            url: errResponse.networkError.url ?? url,
        };
        trackError(EVENT.RECOMMENDATION.ERROR_API_RECOMMENDATION, errorInfo);
        return;
    }
    let res: any = {};
    res = JSON.parse(errResponse);
    trackErrorEvent(res, url, trackError);
};

const trackErrorEvent = (res, url, trackError) => {
    const errorInfo: NetworkErrorInfo = {
        errorType: ErrorType.API_FAILURE,
        url,
        statusCode: res?.error?.statusCode,
        errorData: res?.error,
    };
    trackError(EVENT.RECOMMENDATION.ERROR_API_RECOMMENDATION, errorInfo);
};
